import { Big } from "big.js";
import {
  getSCode,
  HyoziKazeiKbn,
  JuchuSeisanhinKbn,
  ZeiKbn,
} from "messages/codes";
import { UseFormReturn } from "react-hook-form";
import {
  date,
  getHitsuyosu,
  getJodaitanka,
  getJuchuKin,
  getJuchutanka,
  getKakeritsu,
  getUchizeiJuchutanka,
} from "services";
import {
  denpyoshubetcuKbn,
  juchuSeisanhinKbn,
  setshohinKbn,
  shohinshubetsuKbn,
  tankaKbn,
  tenyuryokujodaiKbn,
  uriagesakuseiKbn,
  zaikokanriKbn,
} from "services/codes";
import {
  B000200Get,
  B000200GetByJanCd,
  B010010Nonyu,
  catchRestError,
  RestClient,
} from "..";

// calcserviceに売上で使った～という記載をおこなう
// TODO:詳細設計書 処理詳細 6 5.2.4.1.1.1.1 以下パラメータを設定し～ ☆tokuiCd、tokuishitenCdの記載が抜けてる（B010010/get/tanka (単価取得処理)のパラメータ）
// TODO: 詳細設計書処理詳細 2にjodaihyojiKbnとあるがB020010TokuiResponseにそれはない
// TODO: tokuizipCd等の項目をDBに合わせた変数名にしたい(受注入力も)

const tankaKbnNormal = "0";
const whtankaKbnWh = "0";
// 加算符号のプラス
const kasanfugoPlus: number = 1;

export type B020010CreateRequest = {
  uriYmd: string;
  tokuiCd: string;
  tokuishitenCd: string;
  nonyuCd: string;
  nonyushitenCd: string;
  shainCd: string;
  assistantCd: string;
  uriageKbn: string;
  uridenpyohakoKbn: string;
  seikyushokisaiKbn: string;
  hasokbnCd: string;
  hasosakiCd: string;
  // 明細
  b020010MeiRequestList: B020010CreateMeiRequest[];
} & Partial<{
  uridenpyoNo: string;
  juchudenpyoNo: string;
  senyodenpyoNo: string;
  shukaYmd: string;
  tokuiNm: string;
  tokuizipCd: string;
  tokuiaddress1: string;
  tokuiaddress2: string;
  tokuitelNo: string;
  tokuifaxNo: string;
  nonyuNm: string;
  nonyuzipCd: string;
  nonyuaddress1: string;
  nonyuaddress2: string;
  nonyutelNo: string;
  nonyufaxNo: string;
  bumonCd: string;
  chumonNo: string;
  bikoCd: string;
  biko: string;
  uridenpyohakozumiKbn: string;
  unsogaishaCd: string;
  denpyoshubetsuCd: string;
  tenpudenpyoCd: string;
  denpyoKbn: string;
  ritsu: string;
  bunrui: string;
  hinbetsuNo: string;
  nohinsaki: string;
  uribaNm: string;
  naisen: string;
  tantosha: string;
  uriageSakuseiKbn: string;
  version: string;
}>;

export type B020010CreateMeiRequest = {
  urigyoNo: string;
  uchiwakeKbn: string;
  shohinCd: string;
  urisu: string;
  uritanka: string;
  kakeritsu: string;
  setshohinKbn: string;
} & Partial<{
  uridenpyoNo: string;
  juchudenpyoNo: string;
  juchugyoNo: string;
  sokoCd: string;
  shohinNm: string;
  janCd: string;
  aiteCd: string;
  tenyuryokuuriKbn: string;
  meisaibikoCd: string;
  meisaibiko: string;
  sotosunW: string;
  sotosunH: string;
  uchisunW: string;
  uchisunH: string;
  tenyuryokujodaiKbn: string;
  jodaitanka: string;
  crtDate: string;
  crtshainCd: string;
  // 明細
  b020010MeiKoseiRequestList: B020010CreateMeiKoseiRequest[];
}>;

export type B020010CreateMeiKoseiRequest = {
  urigyoNo: string;
  urikoseigyoNo: string;
  shohinCd: string;
  koseisu: string;
  hitsuyosu: string;
  uritanka: string;
  jodaitanka: string;
  kakeritsu: string;
} & Partial<{
  uridenpyoNo: string;
  juchudenpyoNo: string;
  juchugyoNo: string;
  juchukoseigyoNo: string;
  sokoCd: string;
  shohinNm: string;
  janCd: string;
  aitecd: string;
  tenyuryokuuriKbn: string;
  meisaikoseiBikoCd: string;
  meisaikoseiBiko: string;
  sotosunW: string;
  sotosunH: string;
  uchisunW: string;
  uchisunH: string;
  tenyuryokujodaiKbn: string;
  crtDate: string;
  crtshainCd: string;
}>;

export type B020010CreateRsponse = {
  uridenpyoNo: string;
};

//売上入力登録処理メソッド
export const B020010Create = (methods: UseFormReturn, rows: any) => {
  const fields = methods.getValues();

  // マッピング
  // 明細
  const meiData: B020010CreateMeiRequest[] = rows.map((row: any) => {
    // セット構成品の名称を変更
    row.b020010MeiKoseiRequestList = [...row.koseiData];
    return row;
  });

  // ヘッダー
  const data: B020010CreateRequest = {
    uridenpyoNo: fields.uridenpyoNo,
    juchudenpyoNo: fields.juchudenpyoNo,
    senyodenpyoNo: fields.senyodenpyoNo,
    uriYmd: fields.uriYmd,
    shukaYmd: fields.shukaYmd,
    tokuiCd: fields.tokuiCd,
    tokuishitenCd: fields.tokuishitenCd,
    tokuiNm: fields.tokuiNm,
    tokuizipCd: fields.tokuiPostCd,
    tokuiaddress1: fields.tokuiAddress1,
    tokuiaddress2: fields.tokuiAddress2,
    tokuitelNo: fields.tokuiTelNo,
    tokuifaxNo: fields.tokuiFaxNo,
    nonyuCd: fields.nonyuCd,
    nonyushitenCd: fields.nonyushitenCd,
    nonyuNm: fields.nonyuNm,
    nonyuzipCd: fields.nonyuPostCd,
    nonyuaddress1: fields.nonyuAddress1,
    nonyuaddress2: fields.nonyuAddress2,
    nonyutelNo: fields.nonyuTelNo,
    nonyufaxNo: fields.nonyuFaxNo,
    bumonCd: fields.bumonCd,
    shainCd: fields.shainCd,
    assistantCd: fields.assistantCd,
    uriageKbn: fields.uriageKbn.value,
    chumonNo: fields.chumonNo,
    bikoCd: fields.bikoCd,
    biko: fields.biko,
    uridenpyohakoKbn: fields.uridenpyohakoKbn.value,
    seikyushokisaiKbn: fields.seikyushokisaiKbn.value,
    uridenpyohakozumiKbn: fields.uridenpyohakozumiKbn,
    hasokbnCd: fields.hasokbnCd.value,
    hasosakiCd: fields.hasosakiCd.value,
    unsogaishaCd: fields.unsogaishaCd,
    denpyoshubetsuCd: fields.denpyoshubetsuCd,
    tenpudenpyoCd: fields.tenpudenpyoCd,
    denpyoKbn: fields.denpyoKbn,
    ritsu: fields.ritsu,
    bunrui: fields.bunrui,
    hinbetsuNo: fields.hinbetsuNo,
    nohinsaki: fields.nohinsaki,
    uribaNm: fields.uribaNm,
    naisen: fields.naisen,
    tantosha: fields.tantosha,
    uriageSakuseiKbn: fields.uriageSakuseiKbn,
    version: fields.version,
    b020010MeiRequestList: [...meiData],
  };

  return RestClient.post<B020010CreateRsponse>("b020010/create", data);
};

export type B020010UpdateRequest = {
  uridenpyoNo: string;
  uriYmd: string;
  tokuiCd: string;
  tokuishitenCd: string;
  nonyuCd: string;
  nonyushitenCd: string;
  shainCd: string;
  assistantCd: string;
  uriageKbn: string;
  uridenpyohakoKbn: string;
  seikyushokisaiKbn: string;
  hasokbnCd: string;
  hasosakiCd: string;
  version: string;
  // 明細
  b020010MeiRequestList: B020010UpdateMeiRequest[];
} & Partial<{
  juchudenpyoNo: string;
  senyodenpyoNo: string;
  shukaYmd: string;
  tokuiNm: string;
  tokuizipCd: string;
  tokuiaddress1: string;
  tokuiaddress2: string;
  tokuitelNo: string;
  tokuifaxNo: string;
  nonyuNm: string;
  nonyuzipCd: string;
  nonyuaddress1: string;
  nonyuaddress2: string;
  nonyutelNo: string;
  nonyufaxNo: string;
  bumonCd: string;
  chumonNo: string;
  bikoCd: string;
  biko: string;
  uridenpyohakozumiKbn: string;
  unsogaishaCd: string;
  denpyoshubetsuCd: string;
  tenpudenpyoCd: string;
  denpyoKbn: string;
  ritsu: string;
  bunrui: string;
  hinbetsuNo: string;
  nohinsaki: string;
  uribaNm: string;
  naisen: string;
  tantosha: string;
  uriageSakuseiKbn: string;
}>;

export type B020010UpdateMeiRequest = {
  urigyoNo: string;
  uchiwakeKbn: string;
  shohinCd: string;
  urisu: string;
  uritanka: string;
  kakeritsu: string;
  setshohinKbn: string;
} & Partial<{
  uridenpyoNo: string;
  juchudenpyoNo: string;
  juchugyoNo: string;
  sokoCd: string;
  shohinNm: string;
  janCd: string;
  aiteCd: string;
  tenyuryokuuriKbn: string;
  meisaibikoCd: string;
  meisaibiko: string;
  sotosunW: string;
  sotosunH: string;
  uchisunW: string;
  uchisunH: string;
  tenyuryokujodaiKbn: string;
  jodaitanka: string;
  crtDate: string;
  crtshainCd: string;
  // 明細
  b020010MeiKoseiRequestList: B020010UpdateMeiKoseiRequest[];
}>;

export type B020010UpdateMeiKoseiRequest = {
  urigyoNo: string;
  urikoseigyoNo: string;
  shohinCd: string;
  koseisu: string;
  hitsuyosu: string;
  uritanka: string;
  jodaitanka: string;
  kakeritsu: string;
} & Partial<{
  uridenpyoNo: string;
  juchudenpyoNo: string;
  juchugyoNo: string;
  juchukoseigyoNo: string;
  sokoCd: string;
  shohinNm: string;
  janCd: string;
  aitecd: string;
  tenyuryokuuriKbn: string;
  meisaikoseiBikoCd: string;
  meisaikoseiBiko: string;
  sotosunW: string;
  sotosunH: string;
  uchisunW: string;
  uchisunH: string;
  tenyuryokujodaiKbn: string;
  crtDate: string;
  crtshainCd: string;
}>;

//売上入力更新処理メソッド
export const B020010Update = (methods: UseFormReturn, rows: any) => {
  const fields = methods.getValues();

  // マッピング
  // 明細
  const meiData: B020010UpdateMeiRequest[] = rows.map((row: any) => {
    // セット構成品の名称を変更
    row.b020010MeiKoseiRequestList = [...row.koseiData];
    return row;
  });

  // ヘッダー
  const data: B020010UpdateRequest = {
    uridenpyoNo: fields.uridenpyoNo,
    juchudenpyoNo: fields.juchudenpyoNo,
    senyodenpyoNo: fields.senyodenpyoNo,
    uriYmd: fields.uriYmd,
    shukaYmd: fields.shukaYmd,
    tokuiCd: fields.tokuiCd,
    tokuishitenCd: fields.tokuishitenCd,
    tokuiNm: fields.tokuiNm,
    tokuizipCd: fields.tokuiPostCd,
    tokuiaddress1: fields.tokuiAddress1,
    tokuiaddress2: fields.tokuiAddress2,
    tokuitelNo: fields.tokuiTelNo,
    tokuifaxNo: fields.tokuiFaxNo,
    nonyuCd: fields.nonyuCd,
    nonyushitenCd: fields.nonyushitenCd,
    nonyuNm: fields.nonyuNm,
    nonyuzipCd: fields.nonyuPostCd,
    nonyuaddress1: fields.nonyuAddress1,
    nonyuaddress2: fields.nonyuAddress2,
    nonyutelNo: fields.nonyuTelNo,
    nonyufaxNo: fields.nonyuFaxNo,
    bumonCd: fields.bumonCd,
    shainCd: fields.shainCd,
    assistantCd: fields.assistantCd,
    uriageKbn: fields.uriageKbn.value,
    chumonNo: fields.chumonNo,
    bikoCd: fields.bikoCd,
    biko: fields.biko,
    uridenpyohakoKbn: fields.uridenpyohakoKbn.value,
    seikyushokisaiKbn: fields.seikyushokisaiKbn.value,
    uridenpyohakozumiKbn: fields.uridenpyohakozumiKbn,
    hasokbnCd: fields.hasokbnCd.value,
    hasosakiCd: fields.hasosakiCd.value,
    unsogaishaCd: fields.unsogaishaCd,
    denpyoshubetsuCd: fields.denpyoshubetsuCd,
    tenpudenpyoCd: fields.tenpudenpyoCd,
    denpyoKbn: fields.denpyoKbn,
    ritsu: fields.ritsu,
    bunrui: fields.bunrui,
    hinbetsuNo: fields.hinbetsuNo,
    nohinsaki: fields.nohinsaki,
    uribaNm: fields.uribaNm,
    naisen: fields.naisen,
    tantosha: fields.tantosha,
    uriageSakuseiKbn: fields.uriageSakuseiKbn,
    version: fields.version,
    b020010MeiRequestList: [...meiData],
  };

  return RestClient.put("b020010/update", data);
};

// 商品変更メソッド(商品コード)
export const B020010HandleChangeShohinCd = async (
  methods: UseFormReturn,
  meiMethods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const meiFields = meiMethods.getValues();
  if (meiFields.shohinCd === "") {
    // 受注明細、紐づくセット構成品データの全項目をクリア
    HandleClearMeiByShohinCd(meiMethods);
    return;
  }
  // 商品名、janCd表示
  await B000200Get({ shohinCd: meiFields.shohinCd })
    .then((response) => {
      meiMethods.setValue("janCd", response.data.janCd ?? "");
      meiMethods.setValue("shohinNm", response.data.shohinNm ?? "");
    })
    .catch((reason) => {
      // 返却値が存在しない場合
      // 受注明細、紐づくセット構成品データの全項目をクリア
      HandleClearMeiByShohinCd(meiMethods);

      catchRestError(reason, navigate, setMsg);
    });
  // 商品関連項目設定処理
  await B020010Shohin(methods, meiMethods, navigate, setMsg);
};

// 商品変更メソッド(janコード)
export const B020010HandleChangeJanCd = async (
  methods: UseFormReturn,
  meiMethods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const meiFields = meiMethods.getValues();
  if (meiFields.janCd === "") {
    // 受注明細、紐づくセット構成品データの全項目をクリア
    HandleClearMeiByJanCd(meiMethods);
    return;
  }
  // 商品コード、商品名表示
  await B000200GetByJanCd({ janCd: meiFields.janCd })
    .then((response) => {
      meiMethods.setValue("shohinCd", response.data.shohinCd ?? "");
      meiMethods.setValue("shohinNm", response.data.shohinNm ?? "");
    })
    .catch((reason) => {
      // 返却値が存在しない場合
      // 受注明細、紐づくセット構成品データの全項目をクリア
      HandleClearMeiByJanCd(meiMethods);

      catchRestError(reason, navigate, setMsg);
    });
  // 商品関連項目設定処理
  await B020010Shohin(methods, meiMethods, navigate, setMsg);
};

// 明細クリア(商品コード変更時)
const HandleClearMeiByShohinCd = async (meiMethods: UseFormReturn) => {
  // 受注明細、紐づくセット構成品データの全項目をクリア
  const { shohinCd, meiTab, uchiwakeKbn } = meiMethods.getValues();
  // 明細、セット構成品をクリア(一部の値は保持しておく)
  meiMethods.reset();
  meiMethods.reset({
    ...meiMethods.getValues(),
    janCd: "",
  });
  meiMethods.setValue("shohinCd", shohinCd);
  meiMethods.setValue("meiTab", meiTab);
  meiMethods.setValue("uchiwakeKbn", uchiwakeKbn);
};

// 明細クリア(JANコード変更時)
const HandleClearMeiByJanCd = async (meiMethods: UseFormReturn) => {
  // 受注明細、紐づくセット構成品データの全項目をクリア
  const { janCd, meiTab, uchiwakeKbn } = meiMethods.getValues();
  // 明細、セット構成品をクリア(一部の値は保持しておく)
  meiMethods.reset();
  meiMethods.reset({
    ...meiMethods.getValues(),
    shohinCd: "",
  });
  meiMethods.setValue("janCd", janCd);
  meiMethods.setValue("meiTab", meiTab);
  meiMethods.setValue("uchiwakeKbn", uchiwakeKbn);
};

export type B020010GetShohinRequest = {
  shohinCd: string;
};

export type B020010GetShohinResponse = {
  vol: string;
  kazeiKbn: string;
  tankaKbn: string;
  setshohinKbn: string;
  shohinshubetsuKbn: string;
  sotosunW: string;
  sotosunH: string;
  uchisunW: string;
  uchisunH: string;
  shokuchiKbn: string;
  whtankaCd: string;
  zaikokanriKbn: string;
};

export const B020010GetShohin = (props: B020010GetShohinRequest) => {
  return RestClient.get<B020010GetShohinResponse>("b010010/get/shohin", {
    params: props,
  });
};

//商品マスタ詳細情報取得処理メソッド(商品コード、JANコード入力)
export const B020010Shohin = async (
  methods: UseFormReturn,
  meiMethods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const fields = methods.getValues();
  const meiFields = meiMethods.getValues();
  if (meiFields.shohinCd === "") {
    meiMethods.setValue("vol", "");
    meiMethods.setValue("kazeiKbnView", "");
    meiMethods.setValue("kazeiKbn", "");
    meiMethods.setValue("tankaKbn", "");
    meiMethods.setValue("setshohinKbn", "");
    meiMethods.setValue("shohinshubetsuKbn", "");
    meiMethods.setValue("sotosunW", "");
    meiMethods.setValue("sotosunH", "");
    meiMethods.setValue("uchisunW", "");
    meiMethods.setValue("uchisunH", "");
    meiMethods.setValue("shokuchiKbn", "");
    meiMethods.setValue("kakeritsu", "");
    meiMethods.setValue("whtankaCd", "");
    meiMethods.setValue("zaikokanriKbn", "");
    return;
  }
  await B020010GetShohin({ shohinCd: meiFields.shohinCd })
    .then((response) => {
      meiMethods.setValue("vol", response.data.vol ?? "");
      meiMethods.setValue(
        "kazeiKbnView",
        getSCode(HyoziKazeiKbn, response.data.kazeiKbn ?? "")?.label
      );
      meiMethods.setValue("kazeiKbn", response.data.kazeiKbn ?? "");
      meiMethods.setValue("tankaKbn", response.data.tankaKbn ?? "");
      meiMethods.setValue("setshohinKbn", response.data.setshohinKbn ?? "");
      meiMethods.setValue(
        "shohinshubetsuKbn",
        response.data.shohinshubetsuKbn ?? ""
      );
      meiMethods.setValue("sotosunW", response.data.sotosunW ?? "");
      meiMethods.setValue("sotosunH", response.data.sotosunH ?? "");
      meiMethods.setValue("uchisunW", response.data.uchisunW ?? "");
      meiMethods.setValue("uchisunH", response.data.uchisunH ?? "");
      meiMethods.setValue("shokuchiKbn", response.data.shokuchiKbn ?? "");
      meiMethods.setValue("whtankaCd", response.data.whtankaCd ?? "");
      meiMethods.setValue("zaikokanriKbn", response.data.zaikokanriKbn ?? "");
      // 掛率には得意先.単価掛率を設定
      meiMethods.setValue("kakeritsu", fields.tankaKakeritsu);

      (async () => {
        // 倉庫取得処理
        await B020010Soko(
          fields.uriageSakuseiKbn,
          meiFields.uchiwakeKbn.value,
          meiMethods,
          navigate,
          setMsg
        );

        if (fields.uriageSakuseiKbn === uriagesakuseiKbn.new) {
          // 引当可能数取得処理
          await B020010Kanosu(methods, meiMethods, navigate, setMsg);
        }

        // セット商品の場合
        if (meiMethods.getValues().setshohinKbn === setshohinKbn.set) {
          await B020010Setshohin(methods, meiMethods, navigate, setMsg);
        }
        // セット商品以外の場合
        else {
          // セット構成品データをクリア
          meiMethods.setValue("koseiData", []);

          // 受注生産品区分を設定
          meiMethods.setValue(
            "juchuSeisanhinKbn",
            getSCode(
              JuchuSeisanhinKbn,
              meiMethods.getValues().shohinshubetsuKbn ===
                shohinshubetsuKbn.madeToOrder
                ? juchuSeisanhinKbn.ari
                : juchuSeisanhinKbn.nashi
            )
          );

          // 単価区分「0:通常単価」の場合
          if (meiMethods.getValues().tankaKbn === tankaKbn.tujo) {
            // 単価取得処理
            await B020010Tanka(methods, meiMethods, navigate, setMsg);
          }
          // 単価区分「1:WH単価」の場合
          else if (meiMethods.getValues().tankaKbn === tankaKbn.wh) {
            // WH 単価取得処理
            await B020010WhTanka(methods, meiMethods, navigate, setMsg);
          }
        }
      })();
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      meiMethods.setValue("vol", "");
      meiMethods.setValue("kazeiKbnView", "");
      meiMethods.setValue("kazeiKbn", "");
      meiMethods.setValue("tankaKbn", "");
      meiMethods.setValue("setshohinKbn", "");
      meiMethods.setValue("shohinshubetsuKbn", "");
      meiMethods.setValue("sotosunW", "");
      meiMethods.setValue("sotosunH", "");
      meiMethods.setValue("uchisunW", "");
      meiMethods.setValue("uchisunH", "");
      meiMethods.setValue("shokuchiKbn", "");
      meiMethods.setValue("kakeritsu", "");
      meiMethods.setValue("whtankaCd", "");
      meiMethods.setValue("zaikokanriKbn", "");
      // 受注生産品区分を設定
      meiMethods.setValue(
        "juchuSeisanhinKbn",
        getSCode(JuchuSeisanhinKbn, juchuSeisanhinKbn.nashi)
      );
    });
};

//商品マスタ詳細情報取得処理メソッド(在庫照会ダイアログからの選択)
export const B020010ShohinZaiko = async (
  methods: UseFormReturn,
  meiMethods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const fields = methods.getValues();
  const meiFields = meiMethods.getValues();
  if (meiFields.shohinCd === "") {
    meiMethods.setValue("vol", "");
    meiMethods.setValue("kazeiKbnView", "");
    meiMethods.setValue("kazeiKbn", "");
    meiMethods.setValue("tankaKbn", "");
    meiMethods.setValue("setshohinKbn", "");
    meiMethods.setValue("shohinshubetsuKbn", "");
    meiMethods.setValue("sotosunW", "");
    meiMethods.setValue("sotosunH", "");
    meiMethods.setValue("uchisunW", "");
    meiMethods.setValue("uchisunH", "");
    meiMethods.setValue("shokuchiKbn", "");
    meiMethods.setValue("kakeritsu", "");
    meiMethods.setValue("whtankaCd", "");
    meiMethods.setValue("zaikokanriKbn", "");
    return;
  }
  await B020010GetShohin({ shohinCd: meiFields.shohinCd })
    .then((response) => {
      meiMethods.setValue("vol", response.data.vol ?? "");
      meiMethods.setValue(
        "kazeiKbnView",
        getSCode(HyoziKazeiKbn, response.data.kazeiKbn ?? "")?.label
      );
      meiMethods.setValue("kazeiKbn", response.data.kazeiKbn ?? "");
      meiMethods.setValue("tankaKbn", response.data.tankaKbn ?? "");
      meiMethods.setValue("setshohinKbn", response.data.setshohinKbn ?? "");
      meiMethods.setValue(
        "shohinshubetsuKbn",
        response.data.shohinshubetsuKbn ?? ""
      );
      meiMethods.setValue("sotosunW", response.data.sotosunW ?? "");
      meiMethods.setValue("sotosunH", response.data.sotosunH ?? "");
      meiMethods.setValue("uchisunW", response.data.uchisunW ?? "");
      meiMethods.setValue("uchisunH", response.data.uchisunH ?? "");
      meiMethods.setValue("shokuchiKbn", response.data.shokuchiKbn ?? "");
      meiMethods.setValue("whtankaCd", response.data.whtankaCd ?? "");
      meiMethods.setValue("zaikokanriKbn", response.data.zaikokanriKbn ?? "");
      // 掛率には得意先.単価掛率を設定
      meiMethods.setValue("kakeritsu", fields.tankaKakeritsu);

      (async () => {
        // セット商品の場合
        if (meiMethods.getValues().setshohinKbn === setshohinKbn.set) {
          await B020010Setshohin(methods, meiMethods, navigate, setMsg);
        }
        // セット商品以外の場合
        else {
          // セット構成品データをクリア
          meiMethods.setValue("koseiData", []);

          // 受注生産品区分を設定
          meiMethods.setValue(
            "juchuSeisanhinKbn",
            getSCode(
              JuchuSeisanhinKbn,
              meiMethods.getValues().shohinshubetsuKbn ===
                shohinshubetsuKbn.madeToOrder
                ? juchuSeisanhinKbn.ari
                : juchuSeisanhinKbn.nashi
            )
          );

          // 単価区分「0:通常単価」の場合
          if (meiMethods.getValues().tankaKbn === tankaKbn.tujo) {
            // 単価取得処理
            await B020010Tanka(methods, meiMethods, navigate, setMsg);
          }
          // 単価区分「1:WH単価」の場合
          else if (meiMethods.getValues().tankaKbn === tankaKbn.wh) {
            // WH 単価取得処理
            await B020010WhTanka(methods, meiMethods, navigate, setMsg);
          }
        }
      })();
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      meiMethods.setValue("vol", "");
      meiMethods.setValue("kazeiKbnView", "");
      meiMethods.setValue("kazeiKbn", "");
      meiMethods.setValue("tankaKbn", "");
      meiMethods.setValue("setshohinKbn", "");
      meiMethods.setValue("shohinshubetsuKbn", "");
      meiMethods.setValue("sotosunW", "");
      meiMethods.setValue("sotosunH", "");
      meiMethods.setValue("uchisunW", "");
      meiMethods.setValue("uchisunH", "");
      meiMethods.setValue("shokuchiKbn", "");
      meiMethods.setValue("kakeritsu", "");
      meiMethods.setValue("whtankaCd", "");
      meiMethods.setValue("zaikokanriKbn", "");
      // 受注生産品区分を設定
      meiMethods.setValue(
        "juchuSeisanhinKbn",
        getSCode(JuchuSeisanhinKbn, juchuSeisanhinKbn.nashi)
      );
    });
};

// 倉庫取得処理リクエスト
export type B020010GetSokoRequest = {
  uriageSakuseiKbn: string;
  uchiwakeKbn: string;
};

// 倉庫取得処理レスポンス
export type B020010GetSokoResponse = {
  sokoCd: string;
  sokoNm: string;
  sokoNmr: string;
  sokoKana: string;
  sokoshubetsuKbn: string;
  logicalsokoCd: string;
  physicalsokoCd: string;
  locationkanriKbn: string;
  sakujoyoteiKbn: string;
};

export const B020010GetSoko = (props: B020010GetSokoRequest) => {
  return RestClient.get<B020010GetSokoResponse>("b020010/get/soko", {
    params: props,
  });
};

// 倉庫取得処理メソッド
export const B020010Soko = async (
  uriageSakuseiKbn: string,
  uchiwakeKbn: string,
  meiMethods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  await B020010GetSoko({
    uriageSakuseiKbn: uriageSakuseiKbn,
    uchiwakeKbn: uchiwakeKbn,
  })
    .then((response) => {
      meiMethods.setValue("sokoCd", response.data.sokoCd ?? "");
      meiMethods.setValue("sokoNm", response.data.sokoNm ?? "");
      meiMethods.setValue(
        "sokoshubetsuKbn",
        response.data.sokoshubetsuKbn ?? ""
      );
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      meiMethods.setValue("sokoCd", "");
      meiMethods.setValue("sokoNm", "");
      meiMethods.setValue("sokoshubetsuKbn", "");
    });
};

//セット商品マスタ取得リクエスト
export type B020010FindSetshohinRequest = {
  shohinCd: string;
  uriageSakuseiKbn: string;
  uchiwakeKbn: string;
};

//セット商品マスタ取得レスポンス
export type B020010FindSetshohinResponse = {
  juchukoseigyoNo: string;
  shohinCd: string;
  koseisu: string;
} & Partial<{
  janCd: string;
  shohinNm: string;
  sokoCd: string;
  sokoNm: string;
  sokoshubetsuKbn: string;
  vol: string;
  sotosunW: string;
  sotosunH: string;
  uchisunW: string;
  uchisunH: string;
  kanosu: string;
  jodaitanka: string;
  kazeiKbn: string;
  shohinshubetsuKbn: string;
  tankaKbn: string;
  shokuchiKbn: string;
  whtankaCd: string;
  setshohinKbn: string;
  zaikokanriKbn: string;
}>;

type KoseiData = Partial<{
  uridenpyoNo: string;
  urigyoNo: string;
  urikoseigyoNo: string;
  juchudenpyoNo: string;
  juchugyoNo: string;
  juchukoseigyoNo: string;
  shohinCd: string;
  sokoCd: string;
  shohinNm: string;
  janCd: string;
  aiteCd: string;
  koseisu: string;
  hitsuyosu: string;
  kanosu: string;
  sokoNm: string;
  sokoshubetsuKbn: string;
  vol: string;
  sotosunW: string;
  sotosunH: string;
  uchisunW: string;
  uchisunH: string;
  tenyuryokujodaiKbn: number;
  tenyuryokuuriKbn: number;
  basejodaitanka: string;
  baseuritanka: string;
  jodaitanka: string;
  uritanka: string;
  kakeritsu: string;
  uriKin: string;
  meisaikoseiBikoCd: string;
  meisaikoseiBiko: string;
  kazeiKbn: string;
  shohinshubetsuKbn: string;
  tankaKbn: string;
  shokuchiKbn: string;
  whtankaCd: string;
  zaikokanriKbn: string;
  setshohinKbn: string;
  crtDate: string;
  crtshainCd: string;
}>;

//セット商品マスタ取得メソッド
export const B020010FindSetshohin = (props: B020010FindSetshohinRequest) => {
  return RestClient.get<B020010FindSetshohinResponse[]>("b020010/find", {
    params: props,
  });
};

export const B020010Setshohin = async (
  methods: UseFormReturn,
  meiMethods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const fields = methods.getValues();
  const meiFields = meiMethods.getValues();
  await B020010FindSetshohin({
    shohinCd: meiFields.shohinCd,
    uriageSakuseiKbn: fields.uriageSakuseiKbn,
    uchiwakeKbn: meiFields.uchiwakeKbn.value,
  })
    .then((response) => {
      const fields = methods.getValues();
      const koseiDataList: KoseiData[] = [];
      for (let i: number = 0; i < response.data.length; i++) {
        // 必要数
        const hitsuyosu: string = getHitsuyosu(
          response.data[i].koseisu,
          meiFields.urisu
        );

        // 上代単価
        const jodaitanka = getJodaitanka(
          methods,
          response.data[i].jodaitanka ?? ""
        );

        // 下代単価
        const uritanka: string = getJuchutanka(
          methods,
          jodaitanka,
          fields.tankaKakeritsu
        );

        // 売上金額
        const uriKin: string = getJuchuKin(
          uritanka,
          hitsuyosu,
          fields.kinmarumeKbn
        );

        const koseiData: KoseiData = {
          uridenpyoNo: "",
          urigyoNo: "",
          urikoseigyoNo: response.data[i].juchukoseigyoNo ?? "",
          juchudenpyoNo: "",
          juchugyoNo: "",
          juchukoseigyoNo: "",
          shohinCd: response.data[i].shohinCd ?? "",
          sokoCd: response.data[i].sokoCd ?? "",
          shohinNm: response.data[i].shohinNm ?? "",
          janCd: response.data[i].janCd ?? "",
          aiteCd: "",
          koseisu: response.data[i].koseisu ?? "",
          hitsuyosu: hitsuyosu,
          kanosu: response.data[i].kanosu ?? "",
          sokoNm: response.data[i].sokoNm ?? "",
          sokoshubetsuKbn: response.data[i].sokoshubetsuKbn ?? "",
          vol: response.data[i].vol ?? "",
          sotosunW: response.data[i].sotosunW ?? "",
          sotosunH: response.data[i].sotosunH ?? "",
          uchisunW: response.data[i].uchisunW ?? "",
          uchisunH: response.data[i].uchisunH ?? "",
          tenyuryokujodaiKbn: tenyuryokujodaiKbn.none ?? "",
          tenyuryokuuriKbn: tenyuryokujodaiKbn.none ?? "",
          basejodaitanka: jodaitanka ?? "",
          baseuritanka: uritanka,
          jodaitanka: jodaitanka ?? "",
          uritanka: uritanka,
          kakeritsu: fields.tankaKakeritsu ?? "",
          uriKin: uriKin,
          meisaikoseiBikoCd: "",
          meisaikoseiBiko: "",
          kazeiKbn: response.data[i].kazeiKbn ?? "",
          shohinshubetsuKbn: response.data[i].shohinshubetsuKbn ?? "",
          tankaKbn: response.data[i].tankaKbn ?? "",
          shokuchiKbn: response.data[i].shokuchiKbn ?? "",
          whtankaCd: response.data[i].whtankaCd ?? "",
          setshohinKbn: response.data[i].setshohinKbn ?? "",
          zaikokanriKbn: response.data[i].zaikokanriKbn ?? "",
          crtDate: "",
          crtshainCd: "",
        };

        koseiDataList.push(koseiData);
      }

      meiMethods.setValue("koseiData", koseiDataList);

      // 明細入力部に表示する可能数の設定
      let kanosu: string = "";
      // 構成品に可能数の設定されている行があるかチェック
      const isKanosu: boolean = koseiDataList.some(
        (koseiData: KoseiData) => koseiData.kanosu !== ""
      );
      // 可能数の設定されている行がある場合
      if (isKanosu) {
        kanosu = Math.min(
          ...koseiDataList
            .filter(function (kosei: KoseiData) {
              return kosei.kanosu !== "";
            })
            .map((kosei: KoseiData) => Number(kosei.kanosu))
        ).toString();
      }
      meiMethods.setValue("kanosu", kanosu);

      // 構成品の中に受注生産品が含まれるかどうか
      const isJuchuSeisanhinKbn: boolean = koseiDataList.some(
        (koseiData) =>
          Number(koseiData.shohinshubetsuKbn) === shohinshubetsuKbn.madeToOrder
      );
      // 受注生産品区分を設定
      meiMethods.setValue(
        "juchuSeisanhinKbn",
        getSCode(
          JuchuSeisanhinKbn,
          isJuchuSeisanhinKbn ? juchuSeisanhinKbn.ari : juchuSeisanhinKbn.nashi
        )
      );

      // 売上明細の項目を算出
      // 上代単価(上代 × 構成数)
      const jodaitanka: string = koseiDataList
        .reduce((acc: Big, koseiData: KoseiData): Big => {
          return acc.plus(
            new Big(koseiData.jodaitanka ? koseiData.jodaitanka : "0").times(
              new Big(koseiData.koseisu!)
            )
          );
        }, new Big("0"))
        .toString();

      // 下代単価(下代 × 構成数)
      const uritanka: string = koseiDataList
        .reduce((acc: Big, koseiData: KoseiData): Big => {
          return acc.plus(
            new Big(koseiData.uritanka ? koseiData.uritanka : "0").times(
              new Big(koseiData.koseisu!)
            )
          );
        }, new Big("0"))
        .toString();

      // 掛率(下代単価 ÷ 上代単価 × 100) ※小数点以下切り捨て
      const kakeritsu: string = getKakeritsu(uritanka, jodaitanka);

      // 売上金額(下代単価 × 売上数)
      const uriKin: string = getJuchuKin(
        uritanka,
        meiFields.urisu,
        fields.kinmarumeKbn
      );

      meiMethods.setValue("jodaitanka", jodaitanka);
      meiMethods.setValue("basejodaitanka", jodaitanka);
      meiMethods.setValue("uritanka", uritanka);
      meiMethods.setValue("baseuritanka", uritanka);
      meiMethods.setValue("kakeritsu", kakeritsu);
      meiMethods.setValue("uriKin", uriKin);
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      meiMethods.setValue("koseiData", []);
      meiMethods.setValue("jodaitanka", "");
      meiMethods.setValue("basejodaitanka", "");
      meiMethods.setValue("uritanka", "");
      meiMethods.setValue("baseuritanka", "");
      meiMethods.setValue("kakeritsu", "");
      meiMethods.setValue("uriKin", "");
    });
};

export type B020010GetTankaRequest = {
  tankaKbn: string;
  shohinCd: string;
  tokuiCd: string;
  tokuishitenCd: string;
  kijunDate: string;
};

export type B020010GetTankaResponse = {
  jodaitanka: string;
  juchutanka: string;
  aiteCd: string;
};

export const B020010GetTanka = (props: B020010GetTankaRequest) => {
  return RestClient.get<B020010GetTankaResponse>("b010010/get/tanka", {
    params: props,
  });
};

//単価取得処理メソッド// 詳細設計書にtokuiCd、tokuishitenCdの記載なし
export const B020010Tanka = async (
  methods: UseFormReturn,
  meiMethods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const fields = methods.getValues();
  const meiFields = meiMethods.getValues();

  await B020010GetTanka({
    tankaKbn: tankaKbnNormal,
    shohinCd: meiFields.shohinCd,
    tokuiCd: fields.tokuiCd,
    tokuishitenCd: fields.tokuishitenCd,
    kijunDate: fields.uriYmd,
  })
    .then((response) => {
      // 上代初期値計算処理をよびだす
      const jodaitanka = getJodaitanka(methods, response.data.jodaitanka);
      meiMethods.setValue("jodaitanka", jodaitanka ?? "");
      meiMethods.setValue("basejodaitanka", jodaitanka ?? "");
      meiMethods.setValue("aiteCd", response.data.aiteCd ?? "");

      // 取得した値を元に他項目を算出
      let kakeritsu: string;
      let uritanka: string;

      // 下代単価(売上単価)が取得できた場合
      if (response.data.juchutanka !== null) {
        // 下代単価(売上単価)
        uritanka = getUchizeiJuchutanka(methods, response.data.juchutanka);

        // 掛率(返却された売上単価 * 100 / 返却された上代単価) ※小数点以下切り捨て
        kakeritsu = getKakeritsu(uritanka, jodaitanka);
      }
      // 下代単価(売上単価)が取得できなかった場合(単価マスタが取得できたOR取得できなかった場合)
      else {
        const fields = methods.getValues();
        // 掛率(得意先マスタ.単価掛率)
        kakeritsu = fields.tankaKakeritsu;
        // 下代単価(売上単価)
        uritanka = getJuchutanka(methods, jodaitanka, kakeritsu);
      }

      // 掛率
      meiMethods.setValue("kakeritsu", kakeritsu);
      // 下代単価(売上単価)
      meiMethods.setValue("uritanka", uritanka);
      meiMethods.setValue("baseuritanka", uritanka);
      // 売上金額
      meiMethods.setValue(
        "uriKin",
        getJuchuKin(uritanka, meiMethods.getValues().urisu, fields.kinmarumeKbn)
      );
    })

    // 返却値が存在しない場合、空を設定する
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      meiMethods.setValue("jodaitanka", "");
      meiMethods.setValue("basejodaitanka", "");
      meiMethods.setValue("uritanka", "");
      meiMethods.setValue("baseuritanka", "");
      meiMethods.setValue("aiteCd", "");
      meiMethods.setValue("kakeritsu", "");
      meiMethods.setValue("uritanka", "");
      meiMethods.setValue("uriKin", "");
    });
};

//消費税取得処理リクエスト
export type B020010GetZeiRitsuRequest = {
  kijunYmd: string;
};

//消費税取得処理レスポンス
export type B020010GetZeiRitsuResponse = {
  zeiRitsu: string;
};

export const B020010GetZeiRitsu = (props: B020010GetZeiRitsuRequest) => {
  return RestClient.get<B020010GetZeiRitsuResponse>("b010010/get/shohizei", {
    params: props,
  });
};

//消費税取得処理メソッド
export const B020010ZeiRitsu = async (methods: UseFormReturn) => {
  const fields = methods.getValues();

  console.log(fields);

  // 処理詳細 17
  // 消費税率の設定
  // uriYmd をパラメータに B010010/get/shohizei(消費税取得処理)を実行し返却値を zeiRitsu に設定する。
  await B020010GetZeiRitsu({ kijunYmd: fields.uriYmd }).then((response) => {
    methods.setValue("zeiRitsu", response.data.zeiRitsu ?? "");
  });
};

// 内訳区分取得処理リクエスト
export type B020010GetUchiwakeKbnRequest = {
  denpyoshubetsuKbn: number;
};

// 内訳区分取得処理レスポンス
export type B020010GetUchiwakeKbnResponse = {
  uchiwakeKbn: string;
  uchiwakeNmr: string;
  kasanfugo: number;
};

export const B020010GetUchiwakeKbn = (props: B020010GetUchiwakeKbnRequest) => {
  return RestClient.get<B020010GetUchiwakeKbnResponse[]>(
    "b020010/find/uchiwakeKbnList",
    {
      params: props,
    }
  );
};

// 内訳区分取得処理メソッド
export const B020010UchiwakeKbn = async (
  // setUchiwakeKbnList: Function,
  setKasanfugoPlusList: Function,
  navigate: Function,
  setMsg: Function
) => {
  await B020010GetUchiwakeKbn({ denpyoshubetsuKbn: denpyoshubetcuKbn.uriage })
    .then((response) => {
      // // 内訳区分リストを設定
      // setUchiwakeKbnList(
      //   response.data.map((value) => {
      //     return {
      //       setshohinCd: value.uchiwakeKbn!,
      //       gyoNo: value.uchiwakeNmr!,
      //     };
      //   })
      // );

      // 加算符号がプラスの設定
      setKasanfugoPlusList(
        response.data
          .filter(function (source: B020010GetUchiwakeKbnResponse) {
            return source.kasanfugo === kasanfugoPlus;
          })
          .map((value) => {
            return value.uchiwakeKbn;
          })
      );
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
    });
};

// 処理詳細 2
export type B020010GetTokuiRequest = {
  tokuiCd: string;
  tokuishitenCd: string;
  torihikishuryoYmd: string;
};

// Todo: 詳細設計書処理詳細 2にjodaihyojiKbnとあるがB020010TokuiResponseにそれはない
export type B020010GetTokuiResponse = {
  tokuiNm: string;
  tokuiShokuchiKbn: string;
  tokuiPostCd: string;
  tokuiAddress1: string;
  tokuiAddress2: string;
  tokuiTelNo: string;
  tokuiFaxNo: string;
  nonyuCd: string;
  nonyushitenCd: string;
  shainCd: string;
  shainNm: string;
  eigyoCd: string;
  bumonCd: string;
  bumonNm: string;
  shimeD: string;
  zeiKbn: string;
  zeimarumeKbn: string;
  jodaihyojiKbn: string;
  kinmarumeKbn: string;
  tankamarumeKbn: string;
  tankahasuichi: string;
  tankaKakeritsu: string;
  denpyogyosu: string;
  shokaKbn: number;
};
export const B020010GetTokui = (props: B020010GetTokuiRequest) => {
  return RestClient.get<B020010GetTokuiResponse>("b010010/get/tokui", {
    params: props,
  });
};

//得意関連項目取得処理メソッド
export const B020010Tokui = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const fields = methods.getValues();
  if (fields.tokuiCd === "" || fields.tokuishitenCd === "") {
    methods.setValue("tokuiShokuchiKbn", undefined);
    methods.setValue("tokuiNm", "");
    methods.setValue("tokuiPostCd", "");
    methods.setValue("tokuiAddress1", "");
    methods.setValue("tokuiAddress2", "");
    methods.setValue("tokuiTelNo", "");
    methods.setValue("tokuiFaxNo", "");
    methods.setValue("nonyuCd", "");
    methods.setValue("nonyushitenCd", "");
    methods.setValue("shainCd", "");
    methods.setValue("bumonCd", "");
    methods.setValue("shimeD", "");
    methods.setValue("zeiKbnView", getSCode(ZeiKbn, ""));
    methods.setValue("zeiKbn", "");
    methods.setValue("zeimarumeKbn", "");
    methods.setValue("jodaihyojiKbn", "");
    methods.setValue("kinmarumeKbn", "");
    methods.setValue("tankamarumeKbn", "");
    methods.setValue("tankahasuichi", "");
    methods.setValue("tankaKakeritsu", "");
    methods.setValue("denpyogyosu", "");
    methods.setValue("shokaKbn", "");
    //納入先の関連項目をクリア
    methods.setValue("nonyuShokuchiKbn", "");
    methods.setValue("nonyuNm", "");
    methods.setValue("nonyuPostCd", "");
    methods.setValue("nonyuAddress1", "");
    methods.setValue("nonyuAddress2", "");
    methods.setValue("nonyuTelNo", "");
    methods.setValue("nonyuFaxNo", "");
    methods.setValue("denpyoshubetsuCd", "");
    methods.setValue("denpyoshubetsuNm", "");
    methods.setValue("tenpudenpyoCd", "");
    methods.setValue("tenpudenpyoNm", "");
    methods.setValue("unsogaishaCd", "");
    methods.setValue("unsogaishaNm", "");
    methods.setValue("ritsu", "");
    methods.setValue("denpyoKbn", "");
    methods.setValue("bunrui", "");
    // 売上担当者の関連の項目クリア
    methods.setValue("shainNm", "");
    methods.setValue("bumonCd", "");
    methods.setValue("bumonNm", "");
    methods.setValue("eigyoCd", "");

    return;
  }
  await B020010GetTokui({
    tokuiCd: fields.tokuiCd,
    tokuishitenCd: fields.tokuishitenCd,
    torihikishuryoYmd: date(),
  })
    .then((response) => {
      methods.setValue("tokuiNm", response.data.tokuiNm ?? "");
      methods.setValue(
        "tokuiShokuchiKbn",
        response.data.tokuiShokuchiKbn ?? undefined
      );
      methods.setValue("tokuiPostCd", response.data.tokuiPostCd ?? "");
      methods.setValue("tokuiAddress1", response.data.tokuiAddress1 ?? "");
      methods.setValue("tokuiAddress2", response.data.tokuiAddress2 ?? "");
      methods.setValue("tokuiTelNo", response.data.tokuiTelNo ?? "");
      methods.setValue("tokuiFaxNo", response.data.tokuiFaxNo ?? "");
      methods.setValue("nonyuCd", response.data.nonyuCd ?? "");
      methods.setValue("nonyushitenCd", response.data.nonyushitenCd ?? "");
      methods.setValue("shainCd", response.data.shainCd ?? "");
      methods.setValue("shainNm", response.data.shainNm ?? "");
      methods.setValue("eigyoCd", response.data.eigyoCd ?? "");
      methods.setValue("bumonCd", response.data.bumonCd ?? "");
      methods.setValue("bumonNm", response.data.bumonNm ?? "");
      methods.setValue("shimeD", `締日：${response.data.shimeD ?? ""}`);
      methods.setValue(
        "zeiKbnView",
        getSCode(ZeiKbn, response.data.zeiKbn ?? "")
      );
      methods.setValue("zeiKbn", response.data.zeiKbn ?? "");
      methods.setValue("zeimarumeKbn", response.data.zeimarumeKbn ?? "");
      methods.setValue("jodaihyojiKbn", response.data.jodaihyojiKbn ?? "");
      methods.setValue("kinmarumeKbn", response.data.kinmarumeKbn ?? "");
      methods.setValue("tankamarumeKbn", response.data.tankamarumeKbn ?? "");
      methods.setValue("tankahasuichi", response.data.tankahasuichi ?? "");
      methods.setValue("tankaKakeritsu", response.data.tankaKakeritsu ?? "");
      methods.setValue("denpyogyosu", response.data.denpyogyosu ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("tokuiShokuchiKbn", undefined);
      methods.setValue("tokuiNm", "");
      methods.setValue("tokuiPostCd", "");
      methods.setValue("tokuiAddress1", "");
      methods.setValue("tokuiAddress2", "");
      methods.setValue("tokuiTelNo", "");
      methods.setValue("tokuiFaxNo", "");
      methods.setValue("nonyuCd", "");
      methods.setValue("nonyushitenCd", "");
      methods.setValue("shainCd", "");
      methods.setValue("bumonCd", "");
      methods.setValue("shimeD", "");
      methods.setValue("zeiKbnView", getSCode(ZeiKbn, ""));
      methods.setValue("zeiKbn", "");
      methods.setValue("zeimarumeKbn", "");
      methods.setValue("jodaihyojiKbn", "");
      methods.setValue("kinmarumeKbn", "");
      methods.setValue("tankamarumeKbn", "");
      methods.setValue("tankahasuichi", "");
      methods.setValue("tankaKakeritsu", "");
      methods.setValue("denpyogyosu", "");
      methods.setValue("shokaKbn", "");
      //納入先の関連項目をクリア
      methods.setValue("nonyuShokuchiKbn", "");
      methods.setValue("nonyuNm", "");
      methods.setValue("nonyuPostCd", "");
      methods.setValue("nonyuAddress1", "");
      methods.setValue("nonyuAddress2", "");
      methods.setValue("nonyuTelNo", "");
      methods.setValue("nonyuFaxNo", "");
      methods.setValue("denpyoshubetsuCd", "");
      methods.setValue("denpyoshubetsuNm", "");
      methods.setValue("tenpudenpyoCd", "");
      methods.setValue("tenpudenpyoNm", "");
      methods.setValue("unsogaishaCd", "");
      methods.setValue("unsogaishaNm", "");
      methods.setValue("ritsu", "");
      methods.setValue("denpyoKbn", "");
      methods.setValue("bunrui", "");
      // 売上担当者関連の項目クリア
      methods.setValue("shainNm", "");
      methods.setValue("bumonCd", "");
      methods.setValue("bumonNm", "");
      methods.setValue("eigyoCd", "");
    });

  // 納入先関連項目設定
  await B010010Nonyu(methods, navigate, setMsg);
};

// 可能数取得リクエスト
export type B020010GetKanosuRequest = {
  shohinCd: string;
  sokoCd: string;
} & Partial<{
  sotosunW: string;
  sotosunH: string;
}>;

// 可能数取得レスポンス
export type B020010GetKanosuResponse = {
  kanosu: string;
};

export const B020010GetKanosu = (props: B020010GetKanosuRequest) => {
  return RestClient.get<B020010GetKanosuResponse>("b020010/get/kanosu", {
    params: props,
  });
};

//引当可能数取得処理メソッド
export const B020010Kanosu = async (
  methods: UseFormReturn,
  meiMethods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const fields = methods.getValues();
  const meiFields = meiMethods.getValues();

  if (meiFields.shohinCd === "" || meiFields.sokoCd === "") {
    meiMethods.setValue("kanosu", "");
    return;
  }

  // 売上作成区分が「0:受注確定」の場合
  if (fields.uriageSakuseiKbn === uriagesakuseiKbn.juchuKakutei) {
    // 何もしない
    return;
  }

  // セット商品区分が「1:セット商品」の場合
  if (meiFields.setshohinKbn === setshohinKbn.set) {
    // 何もしない
    return;
  }

  // 在庫管理区分が0「しない」の場合
  if (meiFields.zaikokanriKbn.toString() === zaikokanriKbn.off) {
    // 可能数をクリア
    meiMethods.setValue("kanosu", "");
    return;
  }

  await B020010GetKanosu({
    shohinCd: meiFields.shohinCd,
    sokoCd: meiFields.sokoCd,
    sotosunW: meiFields.sotosunW,
    sotosunH: meiFields.sotosunH,
  })
    .then((response) => {
      meiMethods.setValue("kanosu", response.data.kanosu ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      meiMethods.setValue("kanosu", "");
    });
};

//WH単価取得リクエスト
export type B020010GetWhTankaRequest = {
  whtankaKbn: string;
  whtankaCd: string;
  height: string;
  width: string;
};

//WH単価取得レスポンス
export type B020010GetWhTankaResponse = {
  tanka: string;
};
export const B020010GetWhTanka = (props: B020010GetWhTankaRequest) => {
  return RestClient.get<B020010GetWhTankaResponse>("b010010/get/whtanka", {
    params: props,
  });
};

//WH単価取得処理メソッド
export const B020010WhTanka = async (
  methods: UseFormReturn,
  meiMethods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = meiMethods.getValues();
  // 受注生産品ではない場合
  if (data.shohinshubetsuKbn !== shohinshubetsuKbn.madeToOrder) {
    // 何もしない
    return;
  }

  // 単価区分「0:通常」の場合
  if (data.tankaKbn === tankaKbn.tujo) {
    // 何もしない
    return;
  }

  // 入力済みではない場合
  if (data.whtankaCd === "" || data.sotosunH === "" || data.sotosunW === "") {
    // 可能数をクリア
    meiMethods.setValue("kanosu", "");
    return;
  }

  await B020010GetWhTanka({
    whtankaKbn: whtankaKbnWh,
    whtankaCd: data.whtankaCd,
    height: data.sotosunH,
    width: data.sotosunW,
  })
    .then((response) => {
      // 上代単価取得
      const jodaitanka = getJodaitanka(methods, response.data.tanka);
      // 上代単価
      meiMethods.setValue("jodaitanka", jodaitanka ?? "");
      meiMethods.setValue("basejodaitanka", jodaitanka ?? "");

      // 売上単価取得
      const uritanka: string = getJuchutanka(
        methods,
        jodaitanka,
        meiMethods.getValues().kakeritsu
      );

      // 下代単価(売上単価)
      meiMethods.setValue("uritanka", uritanka);
      meiMethods.setValue("baseuritanka", uritanka);
      // 売上金額
      meiMethods.setValue(
        "uriKin",
        getJuchuKin(
          uritanka,
          meiMethods.getValues().urisu,
          methods.getValues().kinmarumeKbn
        )
      );
    })
    .catch((reason) => {
      // WH単価取得の返却値が存在しない場合、ここに入る
      catchRestError(reason, navigate, setMsg);
      meiMethods.setValue("kanosu", "");
      meiMethods.setValue("jodaitanka", "");
      meiMethods.setValue("basejodaitanka", "");
      meiMethods.setValue("uritanka", "");
      meiMethods.setValue("baseuritanka", "");
      meiMethods.setValue("uriKin", "");
    });
  // 可能数取得
  await B020010Kanosu(methods, meiMethods, navigate, setMsg);
};

// 単価リスト検索リクエスト
export type B020010GetTankaListRequest = {
  tankaKbn: string;
  shohinCdList: string[];
  tokuiCd: string;
  tokuishitenCd: string;
  kijunDate: string;
};

// 単価リスト検索レスポンス
export type B020010GetTankaListResponse = {
  shohinCd: string;
  jodaitanka: string;
  juchutanka: string;
  aiteCd: string;
};

// 単価リスト検索
export const B020010GetTankaList = (props: B020010GetTankaListRequest) => {
  return RestClient.get<B020010GetTankaListResponse[]>("b010010/find/tanka", {
    params: props,
  });
};

//単価リスト検索処理メソッド
export const B020010TankaList = async (
  methods: UseFormReturn,
  shohinCdList: string[],
  rows: any,
  setRows: Function,
  navigate: Function,
  setMsg: Function
) => {
  const fields = methods.getValues();

  await B020010GetTankaList({
    tankaKbn: tankaKbnNormal,
    shohinCdList: shohinCdList,
    tokuiCd: fields.tokuiCd,
    tokuishitenCd: fields.tokuishitenCd,
    kijunDate: fields.uriYmd,
  })
    .then((response) => {
      for (const data of response.data) {
        for (const row of rows) {
          // 商品コードが一致しない場合、何もしない
          if (data.shohinCd !== row.shohinCd) continue;
          // 上代単価が編集されている場合、何もしない
          if (row.tenyuryokujodaiKbn === "1") continue;
          // 下代単価が編集されている場合、何もしない
          if (row.tenyuryokuuriKbn === "1") continue;

          // 上代初期値計算処理をよびだす
          const jodaitanka = getJodaitanka(methods, data.jodaitanka);
          // 取得した値を元に他項目を算出
          let kakeritsu: string;
          let uritanka: string;

          // 下代単価(売上単価)が取得できた場合
          if (data.juchutanka !== null) {
            // 下代単価(売上単価)
            uritanka = getUchizeiJuchutanka(methods, data.juchutanka);

            // 掛率(返却された売上単価 * 100 / 返却された上代単価) ※小数点以下切り捨て
            kakeritsu = getKakeritsu(uritanka, jodaitanka);
          }
          // 下代単価(売上単価)が取得できなかった場合(単価マスタが取得できたOR取得できなかった場合)
          else {
            const fields = methods.getValues();
            // 掛率(得意先マスタ.単価掛率)
            kakeritsu = fields.tankaKakeritsu;
            // 下代単価(売上単価)
            uritanka = getJuchutanka(methods, jodaitanka, kakeritsu);
          }

          // 上代単価
          row.jodaitanka = jodaitanka;
          row.basejodaitanka = jodaitanka;
          // 下代単価(売上単価)
          row.uritanka = uritanka;
          row.baseuritanka = uritanka;
          // 掛率
          row.kakeritsu = kakeritsu;
          // 売上金額
          row.uriKin = getJuchuKin(uritanka, row.urisu, fields.kinmarumeKbn);
        }
      }
      // 明細に反映
      setRows([...rows]);
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
    });
};
